import {LOCALE_ID, NgModule, inject, provideAppInitializer, ErrorHandler} from '@angular/core';
import {AppComponent} from './app.component';
import {AppConfigService} from '@shared/services/app-config.service';
import {browserLanguage, DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS} from '@shared/utils/utils';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from '@shared/shared.module';
import {FrontendModule} from '@frontend/frontend.module';
import {AuthModule} from '@auth/auth.module';
import {PageNotFoundModule} from '@page-not-found/page-not-found.module';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '@env/environment';
import {StoreModule} from '@shared/store/store.module';
import {ServiceModule} from '@shared/services/service.module';
import {AppRoutingModule} from '@app/app-routing.module';
import {TerminalModule} from '@terminal/terminal.module';
import {TreeModule} from '@bugsplat/angular-tree-component';
import {NavigationComponent} from '@frontend/components/navigation/navigation.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {RequestLimitInterceptor} from '@shared/interceptor/RequestLimitInterceptor';
import {AccidentCauseModule} from '@frontend/modules/accident-cause/accident-cause.module';
import {MAT_TOOLTIP_DEFAULT_OPTIONS} from '@angular/material/tooltip';
import {UnauthorizedInterceptor} from '@shared/interceptor/UnauthorizedInterceptor';
import {InitService} from '@shared/services/init.service';
import {ExternalLoginModule} from '@app/external-login/external-login.module';
import {OpenInfoModule} from '@app/open-info/open-info.module';
import {GlobalErrorHandlerService} from '@shared/services/global-error-handler.service';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    StoreModule,
    ServiceModule,
    AuthModule,
    FrontendModule,
    TerminalModule,
    ExternalLoginModule,
    OpenInfoModule,
    AppRoutingModule,
    PageNotFoundModule,
    TreeModule,
    AccidentCauseModule,

  ],
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  providers: [
    InitService,
    AppConfigService,
    provideAppInitializer(() => {
        const initializerFn = ((initService: InitService) => () => initService.initializeApp())(inject(InitService));
        return initializerFn();
      }),
    NavigationComponent,
    {
      provide: LOCALE_ID,
      useValue: browserLanguage,
    },
    {
      provide: DEFAULT_PAGE_SIZE,
      useValue: 15,
    },
    {
      provide: PAGE_SIZE_OPTIONS,
      useValue: [5, 15, 30, 50, 100],
    },
    {provide: HTTP_INTERCEPTORS, useClass: RequestLimitInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true},
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: {
        showDelay: 0,
        hideDelay: 0,
        touchendHideDelay: 1500,
        disableTooltipInteractivity: true
      }
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }
  ],
})
export class AppModule {
}
